export const hasMysqlUtf8UnsupportedChar = value => {
  return /[\uD800-\uDFFF]/.test(value || '')
}
